import React from "react";
import { Row, Col } from 'react-bootstrap'

class Features extends React.Component {
	
	render() {
             
		return (


            <div className="container">
        <div className="features clearfix">
        
       <div className="features__item">
       <Col md={3}>
       <div className="features__item-img">
       <img src={require("../../img/Home/freeshipping.png")}/>
</div>
<div className="features__item-caption">

       <h3> Free Shipping</h3>
       <p> Orders over 800 EGP </p>
       </div>
       </Col>
       </div>
       <div className="features__item">
       <Col md={3}>
       <div className="features__item-img">
       <img src={require("../../img/Home/return.png")}/>
</div>
<div className="features__item-caption">

       <h3> 30 days return</h3>
       <p> If goods have problem </p>
       </div>
       </Col>
       </div>
       <div className="features__item">
       <Col md={3}>
       <div className="features__item-img">
       <img src={require("../../img/Home/securpayment.png")}/>
</div>
<div className="features__item-caption">

       <h3> Secure payment</h3>
       <p> 100% secure payment </p>
       </div>
       </Col>
       </div>
       <div className="features__item">
       <Col md={3}>
       <div className="features__item-img">
       <img src={require("../../img/Home/support.png")}/>
</div>
<div className="features__item-caption">

       <h3> 24h Support</h3>
       <p> Dedicated Support </p>
       </div>
       </Col>
       </div>
       
        </div>
        </div>

       );
    }
  }
  
  export default Features;
  


// WEBPACK FOOTER //
// ./src/Components/Features/Features.jsx